let MultiStepForm = []

// Helper function to get step names for analytics
function getStepName(step) {
  const stepNames = {
    1: "loan_amount",
    2: "personal_info", 
    3: "address_info",
    4: "employment_info",
    5: "bank_details",
    6: "confirmation"
  };
  return stepNames[step] || "unknown_step";
}

jQuery.getJSON("https://api.ipify.org/?format=json", function (data) {
  localStorage.setItem("ip", data.ip)
})

$(document).ready(function() {
  // Attach a delegated event listener to the parent container of the radio buttons
  $('#form-selector-step-2').on('change', 'input[name="LeadForm[housing_type]"]', function() {
    // Get the selected value
    var selectedValue = $(this).val();
    
    // Store the selected value in localStorage
    localStorage.setItem('selectedHousingType', selectedValue);
  });

  // On page load or after dynamically loading inputs, pre-select the stored value
  var storedValue = localStorage.getItem('selectedHousingType');
  if (storedValue) {
    $('input[name="LeadForm[housing_type]"][value="' + storedValue + '"]').prop('checked', true);
  }
});

function sendLead(data) {
  if (data["LeadForm[bank_account_number]"] && !data["LeadForm[bank_account_number]"].startsWith("ES")) {
    data["LeadForm[bank_account_number]"] = "ES" + data["LeadForm[bank_account_number]"];
  }

  jQuery.ajax({
    type: "post",
    dataType: "json",
    url: multiformAjax.ajaxurl,
    timeout: LEAD_SUBMIT_TIMEOUT,
    data: {
      action: "send_lead",
      nonce: multiformAjax.nonce,
      data: {
        lastData: JSON.stringify(data),
        // clients info
        ip_address: String(getFromStorage("ip")),
        loan_sum: localStorage.getItem("loan_sum") ?? 200,
        loan_period: localStorage.getItem("loan_period") ?? 91,
        // external params
        transaction_id: getFromStorage("transaction_id"),
        utm_source: getFromStorage("utm_source"),
        utm_medium: getFromStorage("utm_medium"),
        utm_campaign: getFromStorage("utm_campaign"),
        utm_content: getFromStorage("utm_content"),
        utm_term: getFromStorage("utm_term"),
        click_id: getFromStorage("click_id"),
        visitor_id: getFromStorage("visitor_id"),
        tduid: getFromStorage("tduid"),
        gclid: getFromStorage("gclid"),
        google_client_id: getFromStorage("google_client_id"),
        aff_id: getFromStorage("aff_id"),
        recaptcha_response: getFromStorage("recaptcha-response"),
        current_url: window.location.href
      },
    },
    success: function (response) {
      if (response.action && response.action === "moneyman-step" && response.step !== 3){
        setMultiformData(6)
      }
      else if (response.success) {
        if (response.data == "reCaptcha missing") {
          setMultiformData(1)
        }

        clearAllLocalStorage()

        // An empty or missing redirect_url would leave the user on the overlay.
        setTimeout(() => {
          window.location.href = response.data?.redirect_url || multiformAjax.site_url
        }, [200])
      } else {
        // Check if there's a redirect_url in the error response
        if (response.data?.redirect_url) {

          // Store error message in localStorage to show after redirect
          localStorage.setItem('validation_error_message', 'Por favor inténtalo de nuevo, faltan algunos datos requeridos.');
 
          setTimeout(() => {
            window.location.href = response.data.redirect_url
          }, [200])
        } else {
          setTimeout(() => {
            window.location.href = multiformAjax.site_url
          }, [200])
        }
      }
    },
    // Timeout or transport failure: don't leave the user on the overlay.
    error: function () {
      setTimeout(() => {
        window.location.href = multiformAjax.site_url
      }, [200])
    },
  })
}

function showValidationErrorMessage(message) {
  // Remove any existing validation error message
  jQuery('.validation-error-message').remove();
  
  // Create the error message element
  const errorMessage = `
    <div class="validation-error-message" style="
      background-color: #f8d7da;
      color: #721c24;
      padding: 12px 15px;
      margin-bottom: 20px;
      border: 1px solid #f5c6cb;
      border-radius: 4px;
      font-weight: 500;
      text-align: center;
    ">
      ${message}
    </div>
  `;
  
  // Insert the message above mobile-step-container
  const mobileStepContainer = jQuery('.mobile-step-container');
  if (mobileStepContainer.length) {
    mobileStepContainer.before(errorMessage);
  } else {
    // Fallback: insert at the top of the form container
    const formContainer = jQuery('#multiform-page, .form-container, .simulador-multistep-container').first();
    if (formContainer.length) {
      formContainer.prepend(errorMessage);
    }
  }
  
  // Auto-hide the message after 10 seconds
  setTimeout(() => {
    jQuery('.validation-error-message').fadeOut(500, function() {
      jQuery(this).remove();
    });
  }, 10000);
}

function recaptchaV2Reset(){
  if( $("#recaptcha-container").length ) { // reset if has container
    grecaptcha.reset()
  }
}

function getActiveRecaptcha(){
  return {
    'v2': isRecaptchaV2Active(),
    'v3': isRecaptchaV3Active()
  }
}

function checkSecurity(data) {
  jQuery.ajax({
    type: "post",
    dataType: "json",
    url: multiformAjax.ajaxurl,
    timeout: STEP_REQUEST_TIMEOUT,
    data: {
      action: "check_form_security",
      nonce: multiformAjax.nonce,
      data: {
        email: data["LeadForm[email]"],
        ipAddress: localStorage.getItem("ip") ?? "",
        activeRecaptcha: getActiveRecaptcha(),
        recaptchaResponse: data["g-recaptcha-response"],
        recaptchaResponseV3: data["recaptcha-token-v3"],
        utm_source: getFromStorage("utm_source"),
        utm_medium: getFromStorage("utm_medium"),
        utm_campaign: getFromStorage("utm_campaign"),
        utm_content: getFromStorage("utm_content"),
        utm_term: getFromStorage("utm_term"),
      },
    },
    success: function (response) {
      setMultiformData(2, data, "next")
      $('.steps span').removeClass('active');
      $('.steps span:nth-child(3)').addClass('active');
      // if (response.success) {
      //   setTimeout(() => {
      //     setMultiformData(2, data, "next")
      //   }, 200)
      // } else {
      //   if (response.data == "incorrect email") {
      //     showError(1, "email", "correo-electrónico", "invalid")
      //     recaptchaV2Reset()
      //     recaptchaCallback()
      //     jQuery(`#next-btn-loader-step-1`).hide()
      //     jQuery(`#next-btn-content-step-1`).show()
      //   } else if (response.data == "reCaptcha error") {
      //     recaptchaV2Reset()
      //     recaptchaCallback()
      //   }

      //   scrollToErrorElement()
      // }
    },
    error: function () {
      resetStepButtons(2, "next")
      showValidationErrorMessage(GENERIC_STEP_ERROR)
    },
  })
}

function setMultiformData(step, data, action = null) {
  $('.steps span').removeClass('active');
  $(`.steps span:nth-child(${step + 1})`).addClass('active');
  if (step === 1 && action === 'previous') {
    $('input[type="checkbox"]').each(function() {
      $(this).prop('checked', !$(this).prop('checked'));
    });
  }

  if (data?.['LeadForm[neto_income]'] !== undefined && data?.['LeadForm[monthly_expenses]'] !== undefined) {
    data['LeadForm[neto_income]'] = Math.min(data['LeadForm[neto_income]'], 10000);
    data['LeadForm[monthly_expenses]'] = Math.min(data['LeadForm[monthly_expenses]'], 10000);
  }

  jQuery.ajax({
    type: "post",
    dataType: "json",
    url: multiformAjax.ajaxurl,
    timeout: STEP_REQUEST_TIMEOUT,
    data: {
      action: "set_multiform_data",
      nonce: multiformAjax.nonce,
      customer_name: (step == 2 && action == 'next' && data)
        ? `${data["LeadForm[first_name]"] || ''} ${data["LeadForm[last_name]"] || ''}`.trim()
        : null,
      data: JSON.stringify(data || {}),

      // clients info
      ip_address: String(getFromStorage("ip")),
      loan_sum: localStorage.getItem("loan_sum") ?? 200,
      loan_period: localStorage.getItem("loan_period") ?? 91,
      // external params
      transaction_id: getFromStorage("transaction_id"),
      utm_source: getFromStorage("utm_source"),
      utm_medium: getFromStorage("utm_medium"),
      utm_campaign: getFromStorage("utm_campaign"),
      utm_content: getFromStorage("utm_content"),
      utm_term: getFromStorage("utm_term"),
      click_id: getFromStorage("click_id"),
      visitor_id: getFromStorage("visitor_id"),
      tduid: getFromStorage("tduid"),
      gclid: getFromStorage("gclid"),
      google_client_id: getFromStorage("google_client_id"),
      aff_id: getFromStorage("aff_id"),
      step,
    },
    success: function (response) {
      if (step > 1 && action == "next") {
        jQuery(`#next-btn-loader-step-${step - 1}`).hide()
        jQuery(`#next-btn-content-step-${step - 1}`).show()
      }

      if (action == "previous") {
        jQuery(`#prev-btn-loader-step-${step + 1}`).hide()
        jQuery(`#prev-btn-content-step-${step + 1}`).show()
      }

      if (action == "sidebar") {
        jQuery("#sidebar-menu").removeClass("loading")
      }

      document.getElementById("multiform-page").innerHTML = response.data.output
      prefillForm(step)
      updateStepView(step)
      
      // Initialize fields after prefilling for step 4
      if (step === 4) {
        setTimeout(function() {
          const currentCarOwner = $('input[name="LeadForm[car_owner]"]:checked').val();
          if (currentCarOwner === "YES") {
            $(".field-LeadForm-car_plate_number").show();
            // Initialize validation state for car plate field if it has a value
            const carPlateValue = $("#LeadForm-car_plate_number").val();
            if (carPlateValue && typeof validateCarPlateNumber === 'function') {
              MultiStepForm[4].car_plate_number = validateCarPlateNumber(carPlateValue);
              if (MultiStepForm[4].car_plate_number) {
                showSuccess(4, 'car_plate_number');
              } else {
                $("#LeadForm-car_plate_number").trigger('keyup');
              }
            }
          } else if (currentCarOwner === "NO") {
            $(".field-LeadForm-car_plate_number").hide();
            if (MultiStepForm[4]) {
              MultiStepForm[4].car_plate_number = true;
            }
          }
        }, 100);
      }

      // Store persisted fields in localStorage
      if (response.data.persisted_fields) {
        localStorage.setItem('persisted_fields', JSON.stringify(response.data.persisted_fields));
      }

      // Enhanced dataLayer tracking for all steps
      const persisted = JSON.parse(localStorage.getItem('persisted_fields') || '{}');
      
      // Initialize dataLayer if not exists
      window.dataLayer = window.dataLayer || [];

      // Track form step progression
      dataLayer.push({
        event: "form_step_completed",
        form_name: "loan_application",
        step_number: step,
        step_name: getStepName(step),
      });

      // Enhanced contact and address tracking (steps 2 & 3)
      if ([2, 3].includes(step)) {
        dataLayer.push({
          event: "FormCompleted",
          form_name: step === 2 ? "contact" : "address", 
          step: String(step),
          name: persisted.first_name || '',
          surname: persisted.last_name || '',
          phone: persisted.phone || '',
          email: persisted.email || '',
          postal_code: persisted.postal_code || '',
          country: 'spain' // TODO: Whats this country?
        });
      }

      if (step == 1) {
        jQuery(document).ready(function () {
          setTimeout(function () {
            $('input[type="checkbox"]').each(function() {
              $(this).prop('checked', !$(this).prop('checked'));
            });
          }, 1000)
        })
        //jQuery("#LeadForm-phone").inputmask(masks.phone)
        // jQuery("#LeadForm-phone").mask("+34 X00 000 000", {'translation': {
        //     X: {pattern: /[6|7]/}
        //   }
        // })
        jQuery("#LeadForm-personal_code").inputmask(masks.personal_code)
      }

      if (step == 5) {
        jQuery('#LeadForm-bank_account_number').on('input change', function () {
          this.value = this.value
            .replace(/\D/g, '')
            .slice(0, 32);
        });
      }

      if( step == 2) {
        $('#form-selector-step-2').on('change', 'input[name="LeadForm[housing_type]"]', function() {
          // Get the selected value
          var selectedValue = $(this).val();
          
          // Store the selected value in localStorage
          localStorage.setItem('selectedHousingType', selectedValue);
        });

        var storedValue = localStorage.getItem('selectedHousingType');
        if (storedValue) {
          $('input[name="LeadForm[housing_type]"][value="' + storedValue + '"]')
          .prop('checked', true) 
          .trigger('click')
          .trigger('change');
        }

      } else if ( step == 3 ) {
        $('.field-LeadForm-gender').on('change', 'input[name="LeadForm[gender]"]', function() {
          var selectedValue = $(this).val();
          localStorage.setItem('selectedGender', selectedValue);
        });

        $('.field-LeadForm-phone_plan').on('change', 'input[name="LeadForm[phone_plan]"]', function() {
          var selectedValue = $(this).val();
          localStorage.setItem('selectedPhonePlan', selectedValue);
        });

        var storedValue = localStorage.getItem('selectedGender');
        if (storedValue) {
          $('input[name="LeadForm[gender]"][value="' + storedValue + '"]')
          .prop('checked', true) 
          .trigger('click')
          .trigger('change');
        }

        var storedValue = localStorage.getItem('selectedPhonePlan');
        if (storedValue) {
          $('input[name="LeadForm[phone_plan]"][value="' + storedValue + '"]')
          .prop('checked', true) 
          .trigger('click')
          .trigger('change');
        }

      } else if ( step == 4 ) {
        const defaultOccupation = $('input[name="LeadForm[occupation]"]:checked').val();


        $('.field-LeadForm-occupation').on('change', 'input[name="LeadForm[occupation]"]', function() {
          var selectedValue = $(this).val();
          localStorage.setItem('selectedOccupation', selectedValue);
        });
        $('.field-LeadForm-car_owner').on('change', 'input[name="LeadForm[car_owner]"]', function() {
          var selectedValue = $(this).val();
          localStorage.setItem('selectedCarOwner', selectedValue);
        });
          $('.field-LeadForm-job_area').on('input', 'input[name="LeadForm[job_area]"]', function() {
            $(this).val($(this).val().replace(/[^0-9]/g, ''));
          });
        

        var storedValue = localStorage.getItem('selectedOccupation');
        if (storedValue) {
          $('input[name="LeadForm[occupation]"][value="' + storedValue + '"]')
          .prop('checked', true) 
          .trigger('click')
          .trigger('change');
        }

        // show employment_start_date
        const currentOccupation = $('input[name="LeadForm[occupation]"]:checked').val();
        if (currentOccupation) {
            handleOccupationVisibility(currentOccupation);
        }



        var storedValue = localStorage.getItem('selectedCarOwner');
        if (storedValue) {
          $('input[name="LeadForm[car_owner]"][value="' + storedValue + '"]')
          .prop('checked', true) 
          .trigger('click')
          .trigger('change');
        }
      }
    },
    error: function(xhr) {
      // Always give the button back, otherwise the user is left on a spinner
      resetStepButtons(step, action)

      let message = ""
      try {
        message = JSON.parse(xhr.responseText)?.data?.message ?? ""
      } catch (e) {}

      // 422 from set_multiform_data step 2 = email rejected by ZeroBounce
      if (xhr.status === 422 && step == 2 && message) {
        showError(1, "email", "correo-electrónico", data?.["LeadForm[email]"], message)
        scrollToErrorElement()
        return
      }

      showValidationErrorMessage(GENERIC_STEP_ERROR)
    }
  })
}

// Step 2 runs ZeroBounce + panel persistence (15s curl timeout, retried) server-side
const STEP_REQUEST_TIMEOUT = 90000
// Upper bound for the final submit (panel runs the whole pingtree inline).
// Kept above the server-side cURL timeout in api/BaseApi.php so PHP answers first,
// and below Cloudflare's 100s cut-off (524).
const LEAD_SUBMIT_TIMEOUT = 98000

const GENERIC_STEP_ERROR = "No hemos podido continuar con tu solicitud. Por favor, inténtalo de nuevo."

// Undo the loading state set by readyCurrentForm()/showPreviousForm() when a step request fails
function resetStepButtons(step, action) {
  if (action == "next") {
    jQuery(`#next-btn-loader-step-${step - 1}`).hide()
    jQuery(`#next-btn-content-step-${step - 1}`).show()
  }

  if (action == "previous") {
    jQuery(`#prev-btn-loader-step-${step + 1}`).hide()
    jQuery(`#prev-btn-content-step-${step + 1}`).show()
  }

  if (action == "sidebar") {
    jQuery("#sidebar-menu").removeClass("loading")
  }
}

function showLoadingScreen(show = true) {
  var loaderContainer = jQuery(".simulador-multistep-loader-container")
  loaderContainer.addClass("show")

  var idx = jQuery(".simulador-multistep-loader-text").data("idx")
  var maxLen = jQuery(".simulador-multistep-loader-text p").length

  if (!show) {
    loaderContainer.removeClass("show")
    return
  }

  var prev = jQuery(`.simulador-multistep-loader-text p:eq("${idx - 1}")`)
  prev.removeClass("show")

  var curr = jQuery(`.simulador-multistep-loader-text p:eq("${idx}")`)
  curr.addClass("show")

  var isLastText = idx >= maxLen - 1
  idx = isLastText ? 0 : idx + 1

  jQuery(".simulador-multistep-loader-text").data("idx", idx)

  var time = [2250, 3000, 2000, 3250, 2500]
  var randomTime = time[Math.floor(Math.random() * time.length)]

  setTimeout(showLoadingScreen, randomTime)
}

window.addEventListener('load', function () {
  var container = jQuery("#form-step-container")
  var step 
  
  if (container) {
    step = container.data("step")
  }
  
  // Check for validation error message from localStorage
  const errorMessage = localStorage.getItem('validation_error_message');
  if (errorMessage) {
    // Show the error message
    showValidationErrorMessage(errorMessage);
    // Remove it from localStorage so it doesn't show again
    localStorage.removeItem('validation_error_message');
  }
  
  // Initialize dataLayer and track page view
  window.dataLayer = window.dataLayer || [];
  
  if (step) {
    // Track initial form view
    dataLayer.push({
      event: "form_step",
      form_name: "loan_application",
      step_number: step,
      step_name: getStepName(step),
    });
    
    prefillForm(step)
    updateStepView(step)
  }

  //remove below script for old layout
  // Function to format loan sum with thousands separator
  function formatLoanSum(loanSum) {
    return Number(loanSum).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }

  // Function to update loan value in the DOM
  function updateLoanValue(elementId, value) {
    jQuery("#" + elementId).text(value)
    jQuery(".applying-loan-area").css("display", "flex")
  }

  // Function to handle loan area click event
  function handleLoanAreaClick() {
    jQuery(".loan_modal").addClass("show-loanModal")

    if (loanSum !== null && loanSum !== undefined) {
      var formattedLoanSum = formatLoanSum(loanSum)

      jQuery("#amount_value").text(formattedLoanSum)
      jQuery("#amount_slider").val(loanSum)
    }

    jQuery("html").css("overflow", "hidden")
  }

  // Function to handle close modal click event
  function handleCloseModalClick(event) {
    event.preventDefault(); // Prevent the default behavior of the anchor tag
    jQuery(".loan_modal").removeClass("show-loanModal")

    var updatedLoanValue = jQuery("#amount_slider").val()
    var formattedUpdatedLoanValue = formatLoanSum(updatedLoanValue)

    updateLoanValue("loan__value", formattedUpdatedLoanValue)
    localStorage.setItem("loan_sum", updatedLoanValue)

    jQuery("html").css("overflow", "auto");
  }

  // Main code
  var loanSum = localStorage.getItem("loan_sum") ?? 1500

  if (loanSum !== null && loanSum !== undefined) {
    var formattedLoanSum = formatLoanSum(loanSum)
    updateLoanValue("loan__value", formattedLoanSum)
  }

  jQuery("#loan-area-value").on("click", handleLoanAreaClick)
  jQuery(".close-modal, .close-icon").on("click", handleCloseModalClick)
})
